export const localeKey = 'selectedLocale'

export const SET_LOCALE = 'SET_LOCALE'
